module.exports = __webpack_public_path__ + "static/media/oldportfoliosite.502d48f1.png";